import {
  CURRENT_STAFF_API,
  STAFF_API,
  STAFF_API_LIST,
  STAFF_API_SEARCH,
} from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { PagedResult } from "states/paged-result-model";
import {
  CreateStaffModel,
  SearchStaffRequestModel,
  StaffModel,
  UpdatedStaffModel,
} from "./staff.models";

export const searchStaff = async (
  searchStaffRequestModel: SearchStaffRequestModel
) => {
  const createResponse = await apiClient.postHttp<PagedResult<StaffModel>>(
    `${STAFF_API_SEARCH}`,
    searchStaffRequestModel
  );
  return createResponse;
};

export const getAllStaff = async () => {
  const createResponse = await apiClient.getHttp<StaffModel[]>(
    `${STAFF_API_LIST}`
  );
  return createResponse;
};

export const getStaffById = async (id: number) => {
  return await apiClient.getHttp<StaffModel>(`${STAFF_API}/${id}`);
};

export const addStaff = async (model: CreateStaffModel) => {
  const response = await apiClient.postHttp<number>(`${STAFF_API}`, model);
  return response;
};

export const updateStaff = async (model: UpdatedStaffModel) => {
  const response = await apiClient.putHttp<number>(`${STAFF_API}`, model);
  return response;
};

export const getCurrentStaff = async () => {
  const staff = await apiClient.getHttp<StaffModel>(`${CURRENT_STAFF_API}`);
  return staff.data;
};
